module.exports = __webpack_public_path__ + "static/Action_1-0cf5db3957e2aa367e882e2bd33ccdeb.png";